import { Subject } from "rxjs";
import apiResponse from "../../../../services/apiResponse";
import CreateRepository from "../Repositories/CreateRepository";

class CreateBloc {
  createChannel = new Subject();
  guideCategoryChannel = new Subject();
  repository = new CreateRepository();

  constructor() {
    this.createChannel.next({ status: apiResponse.INITIAL });
    this.guideCategoryChannel.next({ status: apiResponse.INITIAL });
  }

  fetchCreate = async (query) => {
    this.createChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchCreate(query)
      .then((result) => {
        this.createChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.createChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchGuideCategories = async (query) => {
    this.guideCategoryChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchGuideCategories(query)
      .then((result) => {
        this.guideCategoryChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.guideCategoryChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };
}

export default CreateBloc;
